import { FC, useEffect, useMemo, useReducer, useRef, useState, useCallback } from "react";
import { DropdownContainer, NavigationList } from "./CourseInfoList/styles";
import { useTranslation } from "react-i18next";
import ArrowTopIconWithText from "shared/icons/ArrowTopIconWithText";
import { Dropdown } from "@brg/ui";
import { InfoItem } from "./CourseInfoList/components/InfoItem";
import { useLocation } from "react-router-dom";
import styled, { ThemeProvider, useTheme, css } from "styled-components";
import { createThemeByColor } from "shared/helpers/coloring";

const NAVBAR_HEIGHT = 64;
const OFFSET_ELEMENT = 16;
const NULLABLE_POS = 0;

export const FixedContainer = styled.div<{ pos?: number}>`
    position: fixed;
    top: 68px;
    left: 0;
    z-index: 9999;

    a {
        text-decoration: none !important;
    }

`;

export const DropdownBodyWrapper = styled.div<{ visible?: boolean }>`
  
${({ visible }) => visible && css`
  overflow-y: scroll;
  overflow-x: hidden;
`};

  height: 100%;
  scrollbar-width: auto;
  -webkit-scrollbar-width: auto;

  * {
  ::-webkit-scrollbar {
    width: 2px;
    height: 2px;
  }
  ::-webkit-scrollbar-track {
      background: transparent !important;
  }
  ::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: rgba(144, 144, 144, 1);
  }
  }
`;

const getElementPosition = (element: Element) => {
    return element.getBoundingClientRect()?.top
}

export const ProjectAnchorNavigate: FC<{ anchors?: any[], bg?: string, element: HTMLElement }> = ({ anchors = [], bg = '#fff', element }) => {
    const { t } = useTranslation();
    const location = useLocation();
    const theme = useTheme();
    const navRef = useRef<HTMLDivElement>(null);
    const [open, toggleOpen] = useState(false);
    const targetEl = document.getElementById('landing-nav-portal');

    const color = useMemo(() => (bg) , [bg]);
    const { theme: newTheme } = createThemeByColor(color, theme);
    
    const handleClose = useCallback((ev: MouseEvent) => {
        const target = ev.target as Element;
        
        if (navRef.current && navRef.current.contains(target)) {
            return;
        }
        
        if (target && typeof target.className === 'string' && target.className?.includes('baseVal')) {
            return;
        }
    
        toggleOpen(false)
    }, [])

    useEffect(() => {
        window?.addEventListener('click', handleClose);

        return () => {
            window?.removeEventListener('click', handleClose)
        }
    }, [handleClose])

    const [activeHash, setActiveHash] = useState(() => window.location.hash.replace('#', ''));
    useEffect(() => {
        const updateHash = () => setActiveHash(window.location.hash.replace('#', ''));
        window.addEventListener('hashchange', updateHash);
        window.addEventListener('popstate', updateHash);
        return () => {
            window.removeEventListener('hashchange', updateHash);
            window.removeEventListener('popstate', updateHash);
        };
    }, []);

    const containerStyle = {
        marginTop: 0
    }
      

    if (!anchors?.length) {
        return null;
    }

    return (
        <FixedContainer>
            <ThemeProvider theme={newTheme}>
            <NavigationList 
                containerStyles={containerStyle}
            >
                <DropdownContainer
                    visible={open}
                    ref={navRef}
                    className='dropdown-container'
                >
                    <Dropdown 
                        visibility={true}
                        // maxWidth={228 - 32} 
                        maxHeight={350 - 34} 
                        hideArrow 
                        target={
                            <div style={{paddingRight: 16, position: 'relative', zIndex: 999999, borderBottom: '1px solid #464645'}}>
                            <ArrowTopIconWithText 
                                onClick={() => {
                                    toggleOpen(!open)
                                }} 
                                fill={'#909090'} 
                                shrimpIcon 
                                text={t(`project_edit.navigation.structure`)}
                            />

                            </div>
                            
                        }
                    >
                        <DropdownBodyWrapper visible={open}>
                        {!!anchors?.length && anchors?.map(({ postId, anchorText }: any, idx: number) => {
                                const name = anchorText;
                                const link = window.location.pathname + '#' + postId;
                                const isActive = activeHash === postId;

                            return (
                                    <InfoItem 
                                        key={postId + idx}
                                        showOrderNumber={false}
                                        name={name}
                                        tabName={name}
                                        order={0}
                                        href={link}
                                        isActive={isActive} 
                                        postId={postId}
                                    />
                                )
                            })}
                        </DropdownBodyWrapper>

                        </Dropdown>
                </DropdownContainer>
            </NavigationList>
        </ThemeProvider>
        </FixedContainer>

    )
}import { FC, useEffect, useMemo, useReducer, useRef, useState, useCallback } from "react";
import { DropdownContainer, NavigationList } from "./CourseInfoList/styles";
import { useTranslation } from "react-i18next";
import ArrowTopIconWithText from "shared/icons/ArrowTopIconWithText";
import { Dropdown } from "@brg/ui";
import { InfoItem } from "./CourseInfoList/components/InfoItem";
import { useLocation } from "react-router-dom";
import styled, { ThemeProvider, useTheme, css } from "styled-components";
import { createThemeByColor } from "shared/helpers/coloring";

const NAVBAR_HEIGHT = 64;
const OFFSET_ELEMENT = 16;
const NULLABLE_POS = 0;

export const FixedContainer = styled.div<{ pos?: number}>`
    position: fixed;
    top: 68px;
    left: 0;
    z-index: 9999;

    a {
        text-decoration: none !important;
    }

`;

export const DropdownBodyWrapper = styled.div<{ visible?: boolean }>`
  
${({ visible }) => visible && css`
  overflow-y: scroll;
  overflow-x: hidden;
`};

  height: 100%;
  scrollbar-width: auto;
  -webkit-scrollbar-width: auto;

  * {
  ::-webkit-scrollbar {
    width: 2px;
    height: 2px;
  }
  ::-webkit-scrollbar-track {
      background: transparent !important;
  }
  ::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: rgba(144, 144, 144, 1);
  }
  }
`;

const getElementPosition = (element: Element) => {
    return element.getBoundingClientRect()?.top
}

export const ProjectAnchorNavigate: FC<{ anchors?: any[], bg?: string, element: HTMLElement }> = ({ anchors = [], bg = '#fff', element }) => {
    const { t } = useTranslation();
    const location = useLocation();
    const theme = useTheme();
    const navRef = useRef<HTMLDivElement>(null);
    const [open, toggleOpen] = useState(false);
    const targetEl = document.getElementById('landing-nav-portal');

    const color = useMemo(() => (bg) , [bg]);
    const { theme: newTheme } = createThemeByColor(color, theme);
    
    const handleClose = useCallback((ev: MouseEvent) => {
        const target = ev.target as Element;
        
        if (navRef.current && navRef.current.contains(target)) {
            return;
        }
        
        if (target && typeof target.className === 'string' && target.className?.includes('baseVal')) {
            return;
        }
    
        toggleOpen(false)
    }, [])

    useEffect(() => {
        window?.addEventListener('click', handleClose);

        return () => {
            window?.removeEventListener('click', handleClose)
        }
    }, [handleClose])

    const [activeHash, setActiveHash] = useState(() => window.location.hash.replace('#', ''));
    useEffect(() => {
        const updateHash = () => setActiveHash(window.location.hash.replace('#', ''));
        window.addEventListener('hashchange', updateHash);
        window.addEventListener('popstate', updateHash);
        return () => {
            window.removeEventListener('hashchange', updateHash);
            window.removeEventListener('popstate', updateHash);
        };
    }, []);

    const containerStyle = {
        marginTop: 0
    }
      

    if (!anchors?.length) {
        return null;
    }

    return (
        <FixedContainer>
            <ThemeProvider theme={newTheme}>
            <NavigationList 
                containerStyles={containerStyle}
            >
                <DropdownContainer
                    visible={open}
                    ref={navRef}
                    className='dropdown-container'
                >
                    <Dropdown 
                        visibility={true}
                        // maxWidth={228 - 32} 
                        maxHeight={350 - 34} 
                        hideArrow 
                        target={
                            <div style={{paddingRight: 16, position: 'relative', zIndex: 999999, borderBottom: '1px solid #464645'}}>
                            <ArrowTopIconWithText 
                                onClick={() => {
                                    toggleOpen(!open)
                                }} 
                                fill={'#909090'} 
                                shrimpIcon 
                                text={t(`project_edit.navigation.structure`)}
                            />

                            </div>
                            
                        }
                    >
                        <DropdownBodyWrapper visible={open}>
                        {!!anchors?.length && anchors?.map(({ postId, anchorText }: any, idx: number) => {
                                const name = anchorText;
                                const link = window.location.pathname + '#' + postId;
                                const isActive = activeHash === postId;

                            return (
                                    <InfoItem 
                                        key={postId + idx}
                                        showOrderNumber={false}
                                        name={name}
                                        tabName={name}
                                        order={0}
                                        href={link}
                                        isActive={isActive} 
                                        postId={postId}
                                    />
                                )
                            })}
                        </DropdownBodyWrapper>

                        </Dropdown>
                </DropdownContainer>
            </NavigationList>
        </ThemeProvider>
        </FixedContainer>

    )
}